import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MdSwapHoriz } from 'react-icons/md';
import { IoPersonCircle } from 'react-icons/io5';

import styles from './GamepadActionSheet.module.css';

export type GamepadActionSheetProps = {
    showChangeGame: boolean;
    onChangeGame: () => void;
    onProfile: () => void;
    onClose: () => void;
};

export function GamepadActionSheet({ showChangeGame, onChangeGame, onProfile, onClose }: GamepadActionSheetProps) {
    const { t } = useTranslation();
    return (
        <div
            className={styles.backdrop}
            onClick={onClose}
            onKeyDown={(e) => {
                if (e.key === 'Escape') onClose();
            }}
            role="presentation"
        >
            <div
                className={styles.sheet}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                role="presentation"
            >
                <div className={styles.title}>{t('gamepad.freePlay.actionSheet.menu')}</div>
                {showChangeGame && (
                    <button
                        type="button"
                        className={classnames(styles.entry, styles.entryPrimary)}
                        onClick={onChangeGame}
                    >
                        <span className={styles.icon}>
                            <MdSwapHoriz />
                        </span>
                        {t('gamepad.freePlay.changeGame')}
                    </button>
                )}
                <button type="button" className={styles.entry} onClick={onProfile}>
                    <span className={styles.icon}>
                        <IoPersonCircle />
                    </span>
                    {t('gamepad.freePlay.actionSheet.profile')}
                </button>
                <button type="button" className={styles.cancel} onClick={onClose}>
                    {t('gamepad.freePlay.close')}
                </button>
            </div>
        </div>
    );
}
